<template>
    <LayoutHeader :data="content?.config" :navigation="navigation" :media="content?.data" />
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'
import {useNavigation} from "~/composables/useNavigation";

const props = defineProps<{
    content: HblSlot
}>()

const {
    navigation
} = useNavigation()
</script>